define('models/pages/user/details',[
    'underscore',
    'chaplin',
    'models/base/model'
], function(_, Chaplin, Model) {
    'use strict';

    var UserDetailsPageModel = Model.extend({
        urlPath: '/page/user',
        defaults: {
            ID: 0,
            Active: false,
            FIO: '',
            Nick: '',
            _post: '',
            _contactEmail: '',
            _phone: '',
            _address: '',
            skype: '',
            errors: {}
        },
        constructor: function() {
            Model.apply(this, arguments);
        },
        parse: function(data){
            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);

            params.userId = this.get('userId');
            params.type = 'details';
            return params;
        },
        dispose: function() {
            if (this.disposed) {
                return;
            }
            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return UserDetailsPageModel;
});
